import type { ThreadMessage } from '../types';

export const threadHistory: ThreadMessage[] = [
  {
    id: 'm1',
    userName: 'lisa-pm',
    avatarUrl: 'https://ui-avatars.com/api/?name=Lisa+PM&background=36c5f0&color=fff',
    timestamp: '2026-07-30T08:42:00Z',
    text: 'Hey team — we need a way to capture product requirements straight from Slack threads so we stop losing context.',
  },
  {
    id: 'm2',
    userName: 'alex-eng',
    avatarUrl: 'https://ui-avatars.com/api/?name=Alex+Eng&background=ecb22e&color=fff',
    timestamp: '2026-07-30T08:45:00Z',
    text: 'Agreed. Ideally the bot would ask a few clarifying questions, then spit out a PRD markdown file in the thread.',
  },
  {
    id: 'm3',
    userName: 'design-mo',
    avatarUrl: 'https://ui-avatars.com/api/?name=Design+Mo&background=e01e5a&color=fff',
    timestamp: '2026-07-30T08:51:00Z',
    text: 'And let us revise it after approval — like if we later say "add offline mode" it should update the PRD.',
  },
  {
    id: 'm4',
    userName: 'lisa-pm',
    avatarUrl: 'https://ui-avatars.com/api/?name=Lisa+PM&background=36c5f0&color=fff',
    timestamp: '2026-07-30T09:03:00Z',
    text: 'Scope is v1 only: thread mentions, questions with defaults, generated prd.md, and inline mock data. No real Slack API yet.',
  },
];

export const currentUser = {
  userName: 'you',
  avatarUrl: 'https://ui-avatars.com/api/?name=You&background=2eb67d&color=fff',
};
